import { render, staticRenderFns } from "./SentEmailListing.vue?vue&type=template&id=83b787f2&scoped=true&"
import script from "./SentEmailListing.vue?vue&type=script&lang=js&"
export * from "./SentEmailListing.vue?vue&type=script&lang=js&"
import style0 from "./SentEmailListing.vue?vue&type=style&index=0&id=83b787f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b787f2",
  null
  
)

export default component.exports